import { match } from 'ts-pattern'
import { DeviceUrlSlug, DeviceType } from './DeviceSelectionGallery.types'

export function deviceTypeFromUrlSlug(urlSlug: DeviceUrlSlug): DeviceType {
  return match(urlSlug)
    .with('vehicle', () => 'vehicle' as const)
    .with('thermostat', () => 'thermostat' as const)
    .with('vehicle-charger', () => 'vehicleCharger' as const)
    .with('energy-system', () => 'energySystem' as const)
    .with('home', () => 'home' as const)
    .exhaustive()
}
